export const CREATE_JOB_WORK_ISSUE = 'CREATE_JOB_WORK_ISSUE';
export const GET_JOB_WORK_ISSUE = 'GET_JOB_WORK_ISSUE';
export const JOB_WORK_ISSUE_REQUEST = 'JOB_WORK_ISSUE_REQUEST';
export const JOB_WORK_ISSUE_REQUEST_SUCCESS = 'JOB_WORK_ISSUE_REQUEST_SUCCESS';
export const UPDATE_JOB_WORK_ISSUE = 'UPDATE_JOB_WORK_ISSUE';
export const DELETE_JOB_WORK_ISSUE = 'DELETE_JOB_WORK_ISSUE';
export const JOB_WORK_ISSUE_REQUEST_FAILURE = 'JOB_WORK_ISSUE_REQUEST_FAILURE';
export const GET_JOB_WORK_ISSUES_PAGE = 'GET_JOB_WORK_ISSUES_PAGE';
export const JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST = 'JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST';
export const JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE = 'JOB_WORK_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE';
export const GET_JOB_WORK_ISSUE_AVAILABLE_TRANSACTIONS = 'GET_JOB_WORK_ISSUE_AVAILABLE_TRANSACTIONS';
export const RESET_JOB_WORK_ISSUE_AVAILABLE_TRANSACTIONS = 'RESET_JOB_WORK_ISSUE_AVAILABLE_TRANSACTIONS';

